export const strings = {
  nav: {
    fr: {
      accueil: "Accueil",
      histoire: "Notre Histoire",
      livret: "Le Livret",
      boutique: "La Boutique",
      livreOr: "Livre d'Or",
      photos: "Photos & Vidéos",
      menu: "Menu",
    },
    en: {
      accueil: "Home",
      histoire: "Our Story",
      livret: "The Anniversary Book",
      boutique: "The Store",
      livreOr: "Guestbook",
      photos: "Photos & Videos",
      menu: "Menu",
    },
  },
  footer: {
    fr: {
      tagline: "Depuis 1956, une histoire de famille.",
      phone: "01 40 29 02 20",
      histoire: "Notre Histoire",
      livret: "Le Livret 70 ans",
      boutique: "La Boutique",
      livreOr: "Livre d'Or",
      photos: "Photos & Vidéos",
    },
    en: {
      tagline: "A family story since 1956.",
      phone: "+33 (0)1 40 29 02 20",
      histoire: "Our Story",
      livret: "The 70th Anniversary Book",
      boutique: "The Store",
      livreOr: "Guestbook",
      photos: "Photos & Videos",
    },
  },
  home: {
    fr: {
      eyebrow: "Paris · Le Marais — Depuis 1956",
      tagline: "L'histoire d'une maison familiale depuis 1956",
      cta: "Découvrir notre histoire",
      introTitle: "Une maison de famille",
      p1: "Depuis 1956, Roganel écrit une histoire de famille, de rencontres, de marques et de passion.",
      p2: "De Parisex à Roganel, de Blois à Tours puis Paris, trois générations ont participé à cette aventure.",
      p3: "Depuis 1988, le 23 rue des Archives, au cœur du Marais, est devenu le cœur de cette histoire.",
    },
    en: {
      eyebrow: "Paris · Le Marais — Since 1956",
      tagline: "The story of a family business since 1956",
      cta: "Discover our story",
      introTitle: "A family business",
      p1: "Since 1956, Roganel has been shaped by family, encounters, iconic brands and a shared passion.",
      p2: "From Parisex to Roganel, from Blois to Tours and finally Paris, three generations have contributed to this adventure.",
      p3: "Since 1988, 23 rue des Archives, in the heart of Le Marais, has been at the centre of our story.",
    },
  },
  histoire: {
    fr: {
      eyebrow: "Trois générations — depuis 1956",
      title: "NOTRE HISTOIRE",
      subtitleA: "De Parisex à Roganel, de Blois à Tours puis Paris",
      subtitleB: "— les grandes étapes d'une aventure familiale.",
      quote: "« Cette histoire est la nôtre, mais elle est aussi devenue un peu la vôtre. Merci d'en faire partie. »",
      signature: "Karine Lévy — Troisième génération",
      cta: "Feuilleter le livret",
    },
    en: {
      eyebrow: "Three generations — since 1956",
      title: "OUR STORY",
      subtitleA: "From Parisex to Roganel, from Blois to Tours and finally Paris",
      subtitleB: " — the milestones of a family adventure.",
      quote: "“This story is ours, but over the years it has also become a little bit yours. Thank you for being part of it.”",
      signature: "Karine Lévy — Third generation",
      cta: "Explore the anniversary book",
    },
  },
  livret: {
    fr: {
      eyebrow: "Édition anniversaire — 1956 · 2026",
      title: "LE LIVRET 70 ANS",
      subtitle: "Roganel — L'histoire d'une maison familiale depuis 1956",
      presentationText: "De Parisex à Roganel, de Blois à Tours puis Paris : les rencontres, les marques et les moments qui ont construit l'identité de la maison, racontés par Karine Lévy, troisième génération. Un livret réalisé à l'occasion du 70ᵉ anniversaire de Roganel.",
      flipbook: "Feuilleter le livret",
      download: "Télécharger le livret",
      invite: "Installez-vous confortablement, et tournez les pages comme sur le livret papier.",
      openViewer: "Ouvrir la visionneuse",
      page: "Page",
      close: "Fermer",
      prev: "Précédent",
      next: "Suivant",
    },
    en: {
      eyebrow: "Anniversary Edition — 1956 · 2026",
      title: "THE 70TH ANNIVERSARY BOOK",
      subtitle: "Roganel — The story of a family business since 1956",
      presentationTitle: "Seventy years, brought together in one book",
      presentationText: "From Parisex to Roganel, from Blois to Tours and finally Paris: the encounters, brands and defining moments that shaped the identity of the house, told by Karine Lévy, third generation. A book created to celebrate Roganel’s 70th anniversary.",
      flipbook: "Explore the book",
      download: "Download the book",
      frenchNote: "Book available in French",
      invite: "Make yourself comfortable and turn the pages just like the printed edition.",
      openViewer: "Open the viewer",
      page: "Page",
      close: "Close",
      prev: "Previous",
      next: "Next",
    },
  },
  boutique: {
    fr: {
      eyebrow: "Le Marais — Paris 4ᵉ",
      title: "LA BOUTIQUE",
      phone: "01 40 29 02 20",
      directions: "Itinéraire — Google Maps",
      reviews: "Voir nos avis Google",
      mention: "Vêtements & accessoires pour homme — marques indépendantes",
      hoursTitle: "Horaires d'ouverture",
      hours: [
        { key: "lundi", day: "Lundi", time: "12h00 — 19h30" },
        { key: "mardi-samedi", day: "Mardi — Samedi", time: "10h30 — 19h30" },
        { key: "dimanche", day: "Dimanche", time: "12h00 — 19h30" },
      ],
      quote: "« À l'heure où le commerce se digitalise, Roganel fait un choix assumé : rester avant tout un magasin de proximité. Ici, chaque produit est sélectionné, essayé, raconté et conseillé. »",
      contactTitle: "NOUS ÉCRIRE",
      contactIntro: "Une question, un conseil, une recherche particulière ? Écrivez-nous, nous vous répondrons très vite.",
      nameLabel: "Nom",
      namePlaceholder: "Votre nom",
      emailLabel: "E-mail",
      emailPlaceholder: "votre@email.fr",
      messageLabel: "Message",
      messagePlaceholder: "Votre message…",
      send: "Envoyer",
      sending: "Envoi en cours…",
      confirmTitle: "Merci, votre message a bien été envoyé.",
      confirmText: "Nous vous répondrons très vite à l'adresse indiquée.",
      another: "Écrire un autre message",
      error: "Une erreur est survenue, merci de réessayer.",
    },
    en: {
      eyebrow: "Le Marais — Paris 4th arrondissement",
      title: "THE STORE",
      phone: "+33 (0)1 40 29 02 20",
      directions: "Directions — Google Maps",
      reviews: "Read our Google reviews",
      mention: "Menswear & accessories — independent brands",
      hoursTitle: "Opening hours",
      hours: [
        { key: "lundi", day: "Monday", time: "12:00 pm — 7:30 pm" },
        { key: "mardi-samedi", day: "Tuesday — Saturday", time: "10:30 am — 7:30 pm" },
        { key: "dimanche", day: "Sunday", time: "12:00 pm — 7:30 pm" },
      ],
      quote: "“At a time when retail is becoming increasingly digital, Roganel has made a deliberate choice: to remain, above all, a neighbourhood store. Every piece we carry is carefully selected, tried, explained and personally recommended.”",
      contactTitle: "GET IN TOUCH",
      contactIntro: "Looking for something in particular, need some advice or simply have a question? Send us a message and we’ll get back to you very soon.",
      nameLabel: "Name",
      namePlaceholder: "Your name",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      messageLabel: "Message",
      messagePlaceholder: "Your message…",
      send: "Send",
      sending: "Sending…",
      confirmTitle: "Thank you, your message has been sent.",
      confirmText: "We’ll get back to you very soon at the email address you provided.",
      another: "Send another message",
      error: "Something went wrong. Please try again.",
    },
  },
  livreOr: {
    fr: {
      eyebrow: "Souvenirs & rencontres — depuis 1956",
      title: "LE LIVRE D'OR ROGANEL",
      p1: "Une histoire comme celle de Roganel s'écrit aussi avec ceux qui l'ont accompagnée.",
      p2: "Clients, amis, partenaires, marques, collaborateurs… laissez-nous un souvenir, une anecdote ou simplement quelques mots.",
      nameLabel: "Prénom et nom",
      namePlaceholder: "Votre nom",
      messageLabel: "Message",
      messagePlaceholder: "Un souvenir, une anecdote, quelques mots…",
      submit: "Laisser mon message",
      sending: "Envoi en cours…",
      error: "Une erreur est survenue, merci de réessayer.",
      confirmTitle: "Merci beaucoup.",
      confirmText: "Votre message a bien été reçu. Il sera relu par la maison avant d'être publié dans le livre d'or.",
      another: "Laisser un autre message",
      messagesTitle: "Ils ont écrit",
      empty: "Les premiers messages validés apparaîtront ici très bientôt.",
    },
    en: {
      eyebrow: "Memories & encounters — since 1956",
      title: "THE ROGANEL GUESTBOOK",
      p1: "A story like Roganel’s is also written by all those who have been part of it along the way.",
      p2: "Customers, friends, partners, brands, colleagues… share a memory, an anecdote or simply a few words with us.",
      nameLabel: "First and last name",
      namePlaceholder: "Your name",
      messageLabel: "Message",
      messagePlaceholder: "A memory, an anecdote, a few words…",
      submit: "Leave a message",
      sending: "Sending…",
      error: "Something went wrong. Please try again.",
      confirmTitle: "Thank you so much.",
      confirmText: "Your message has been received. It will be reviewed by the Roganel team before being published in the guestbook.",
      another: "Leave another message",
      messagesTitle: "They left a message",
      empty: "The first approved messages will appear here very soon.",
    },
  },
  photos: {
    fr: {
      eyebrow: "Roganel — 70 ans",
      title: "LA FÊTE ROGANEL",
      subtitle: "24 septembre 2026",
      text: "Les souvenirs de cette soirée seront bientôt ici…",
      note: "Photographies & vidéos publiées après la soirée",
    },
    en: {
      eyebrow: "Roganel — 70 years",
      title: "THE ROGANEL CELEBRATION",
      subtitle: "September 24, 2026",
      text: "Memories from this special evening will soon be here…",
      note: "Photos & videos will be published after the event",
    },
  },
};
